import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClinicFormGroupDefaultService {
  private API_URL= environment.API_URL;
  private API_KEY = environment.API_KEY;

  constructor(private http: HttpClient) { }

  GetClinicFormGroup(branchID) 
  {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const body = new URLSearchParams();
    body.set('BranchID', branchID);
    return this.http.post(this.API_URL + 'ClinicGroupForm/GetAllGroupForm', body.toString(), { headers }).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          console.log("ERROR", error);
          return throwError('GetClinicFormGroup, Something went wrong!');
        })
     );
  }

  SaveClinicFormGroup(models:ClinicFormGroup[]) 
  {
    console.log(models);
    return this.http.post(this.API_URL + 'ClinicGroupForm/SaveGroupForm', models).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError(() => 'Update Clinic FormType went wrong!' );
        })
    );
  }
}

export class ClinicFormGroup {
  branchFormGroupID: number;
  branchID: number;
  formType: string;
  checked: boolean;
  addBy:number;
  addOn:Date;
  updateBy:number;
  updateOn:Date;
  groupName:string;
}